import script from "./RulesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RulesView.vue?vue&type=script&setup=true&lang=ts"

import "./RulesView.vue?vue&type=style&index=0&id=628ef268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628ef268"]])

export default __exports__